/*
These functions make sure WordPress
and Foundation play nice together.
*/
jQuery(document).ready(function() {
	
	// Remove empty P tags created by WP inside of Accordion and Orbit
	jQuery('.accordion p:empty, .orbit p:empty').remove();

	// Adds Flex Video to YouTube and Vimeo Embeds
	jQuery('iframe[src*="youtube.com"], iframe[src*="vimeo.com"]').each(function() {
		if ( jQuery(this).innerWidth() / jQuery(this).innerHeight() > 1.5 ) {
		  jQuery(this).wrap("<div class='widescreen responsive-embed'/>");
		} else {
		  jQuery(this).wrap("<div class='responsive-embed'/>");
		}
	});

	//show more button
	jQuery( "button.showMore" ).click(function(event) {
		event.preventDefault();
		jQuery( ".logo-show-hide" ).slideToggle( "slow" );
			var $this = jQuery(this);
			  $this.toggleClass("open");
	  
			  if ($this.hasClass("open")) {
				  $this.html("See Less Partners");
			  } else {
				  $this.html("See More Partners");
			  }
	  });

	//show more with fade
	jQuery( "button.showMoreTwo" ).click(function(event) {
		event.preventDefault();
		jQuery( ".logo-show-hide" ).slideToggle("slow");
		jQuery(".secondRow").toggleClass('fadeLogos')
		jQuery(".buttonUp").toggleClass('buttonMargin')
		var $this = jQuery(this);
			  $this.toggleClass("open");
	  
			  if ($this.hasClass("open")) {
				  $this.html("See Less Partners");
			  } else {
				  $this.html("See More Partners");
			  }
	  });
}); 

//Slider Hover
const allContainers = document.querySelectorAll('.container')
const firstText = document.querySelectorAll('.a-text')
const secondText = document.querySelectorAll('.b-text')

function show() {
  firstText.forEach((ele) =>{
    ele.classList.remove('hideHeadings')
  })
  secondText.forEach((elem) =>{
    elem.classList.add('hideHeadings')
  })
}

function hide() {
  firstText.forEach((ele) =>{
    ele.classList.add('hideHeadings')
  })
  secondText.forEach((elem) =>{
    elem.classList.remove('hideHeadings')
  })
}

const allContainers2 = document.querySelectorAll('.container2')
const firstText2 = document.querySelectorAll('.a-text2')
const secondText2 = document.querySelectorAll('.b-text2')

function show2() {
  firstText2.forEach((ele) =>{
    ele.classList.remove('hideHeadings')
  })
  secondText2.forEach((elem) =>{
    elem.classList.add('hideHeadings')
  })
}

function hide2() {
  firstText2.forEach((ele) =>{
    ele.classList.add('hideHeadings')
  })
  secondText2.forEach((elem) =>{
    elem.classList.remove('hideHeadings')
  })
}

//Hotspot 
const selectHotspot = (e) => {
	const clickedHotspot = e.target.parentElement;
	const container = clickedHotspot.parentElement;
	
	// only include hotspots within same image to allow one open hotspot per image; change "container" to "document" to allow only one open hotspot for entire page:
	const hotspots = container.querySelectorAll(".lg-hotspot"); 
	hotspots.forEach(hotspot => {
	  if (hotspot === clickedHotspot) {
		hotspot.classList.toggle("lg-hotspot--selected");
	  } else {
		hotspot.classList.remove("lg-hotspot--selected");
	  }
	});
  }
  
  (() => {
	const buttons = document.querySelectorAll(".lg-hotspot__button");
	buttons.forEach(button => {
		button.addEventListener("mouseover", selectHotspot);
		button.addEventListener("mouseleave", selectHotspot)
	});
  })();
  
  (() => {
	const buttons = document.querySelectorAll(".lg-hotspot__buttonTwo");
	buttons.forEach(button => {
		button.addEventListener("mouseover", selectHotspot);
		button.addEventListener("mouseleave", selectHotspot)
	});
  })();


  const selectHotspotThree = (e) => {
	const clickedHotspotThree = e.target.parentElement;
	const containerThree = clickedHotspotThree.parentElement;
	
	// only include hotspots within same image to allow one open hotspot per image; change "container" to "document" to allow only one open hotspot for entire page:
	const hotspotsThree = containerThree.querySelectorAll(".lg-hotspotThree"); 
	hotspotsThree.forEach(hotspotThree => {
	  if (hotspotThree === clickedHotspotThree) {
		hotspotThree.classList.toggle("lg-hotspotThree--selected");
	  } else {
		hotspotThree.classList.remove("lg-hotspotThree--selected");
	  }
	});
  }


  (() => {
	const buttonsThree = document.querySelectorAll(".lg-hotspotThree__buttonThree");
	buttonsThree.forEach(buttonThree => {
		buttonThree.addEventListener("mouseover", selectHotspotThree);
		buttonThree.addEventListener("mouseleave", selectHotspotThree)
	});
  })();
 
  function addAriaToSplide(){
    document.getElementById('splide01').setAttribute('aria-label', 'carousel');
    document.getElementById('splide02').setAttribute('aria-label', 'carousel');
};
window.onload = addAriaToSplide;